import React from 'react';
import { Star, Waves } from 'lucide-react';
import { GoogleG } from './GoogleReviewBadge';

/**
 * RatingStack — BookingFlows + Google ratings stacked, clearly branded.
 * BF row scrolls to on-page reviews; Google row opens the operator's
 * Google reviews. Renders nothing for sources with no reviews.
 */
const RatingStack = ({ bfRating, bfCount, googleReviews, onBfClick, bfTestId = 'rating-stack-bf' }) => {
  const hasBf = Number(bfCount) > 0;
  const hasGoogle = Boolean(googleReviews?.count);
  if (!hasBf && !hasGoogle) return null;

  const openGoogle = (e) => {
    e.stopPropagation();
    if (googleReviews?.url) window.open(googleReviews.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="flex flex-col gap-1.5" data-testid="rating-stack">
      {hasBf && (
        <button
          type="button"
          onClick={onBfClick}
          data-testid={bfTestId}
          className="flex w-fit items-center gap-2 hover:opacity-75 transition-opacity"
        >
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-blue-600">
            <Waves className="h-3 w-3 text-white" strokeWidth={2.5} />
          </span>
          <span className="text-xs font-bold text-gray-900">BookingFlows</span>
          <span className="flex items-center gap-1 text-xs">
            <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
            <span className="font-bold text-gray-900 tabular-nums">{Number(bfRating || 0).toFixed(1)}</span>
            <span className="text-gray-400">· {bfCount} review{Number(bfCount) !== 1 ? 's' : ''}</span>
          </span>
        </button>
      )}
      {hasGoogle && (
        <button
          type="button"
          onClick={openGoogle}
          data-testid="rating-stack-google"
          className="flex w-fit items-center gap-2 hover:opacity-75 transition-opacity"
        >
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-gray-50">
            <GoogleG className="w-3 h-3" />
          </span>
          <span className="text-xs font-bold text-gray-900">Google</span>
          <span className="flex items-center gap-1 text-xs">
            <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
            <span className="text-gray-400">{Number(googleReviews.count).toLocaleString('en-US')}+ reviews</span>
          </span>
        </button>
      )}
    </div>
  );
};

export default RatingStack;
